export default {
    "en": {
        "global": {
            "cancel": "Cancel",
            "save": "Save",
            "closed": "Closed",
            "confirm": "Confirm",
            "discard": "Discard",
            "unsaved_changes_discard_them": "You have unsaved changes! Do you want to discard them?",
            "remove": "Remove",
            "add": "Add",
            "loading": "Data is loading. Please wait...",
            "tip": "Tip",
            "item": "Item",
            "date_time": "Date Time",
            "cost": "Cost",
            "weight": "Weight",
            "see_more": "See more",
            "see_less": "See less",
            "learn_more": "Learn More",
            "over_time": "Over Time",
            "filter": "Filter",
            "order": "Order",
            "all": "All",
            "no_more_data": "No more data",
            "try_again": "Try again",
            "hide": "Hide",
            "warning": "Warning",
            "save_changes": "Save changes",
            "baseline": "Baseline",
            "beforeMeasStart": "Before measurement start",
            "invalid_date": "Invalid date"
        },
        "time": {
            "now": "Now",
            "from": "From",
            "to": "To",
            "start_date": "Start date",
            "end_date": "End date"
        },
        "days": {
            "monday": "Monday",
            "tuesday": "Tuesday",
            "wednesday": "Wednesday",
            "thursday": "Thursday",
            "friday": "Friday",
            "saturday": "Saturday",
            "sunday": "Sunday"
        },
        "settings": {
            "settings": "Settings",
            "guest_count": "Guest count",
            "inventory": "Inventory",
            "service_times": "Service times",
            "start_date_exists": "Start date already used"
        },
        "guest_count": {
            "last_edited_by": "<b>Last Edited</b> by {name} on {date}",
            "default_value": "Default Value",
            "global_default_value": "Global default value",
            "monthly_default_value": "Month default value",
            "show_days_with_default_value": "Show days with default value",
            "set_default_values": "Set default values",
            "set_global_default_values": "Set global default values",
            "set_monthly_default_values": "Set month default values",
            "data_entry_settings": "Data entry settings",
            "date": "Date",
            "morning": "Morning",
            "midday": "Day",
            "midday_secondary": "Midday",
            "evening": "Evening",
            "total": "Total",
            "default": "Default",
            "if_global_guest_count_is_not_enter": "Saving this new default replaces all past entries and empty fields with the new default number.",
            "please_enter_global_guest_count": "Please enter your default daily average number of guests served:",
            "if_monthly_guest_count_is_not_enter": "Saving this number will only adjust the fields in the month currently in view.",
            "please_enter_monthly_guest_count": "Please enter your default daily average number of guests served for the month selected:",
            "warning_global": "Warning! Changing this will overwrite all previously entered numbers for everyone in your team!",
            "warning_monthly": "Warning! Changing this will overwrite any previously entered numbers in this month for everyone in your team since the start of the measurements!",
            "guest_count_data_entry": "Guest count data entry",
            "enter_actual_or_average": "By default, will you enter actual daily guest count or just a monthly average?",
            "per_day": "Per day",
            "monthly_average_only": "Monthly average",
            "default_values": "Default Values",
            "what_are_they": "What are they?",
            "default_values_are_automatically_put": "Default values are automatically put in cells that you left empty. They are used to give you approximate statistics even if you did not enter your real guest count in all cells.",
            "recommend_enter_guest_count": "We recommend that you always enter your real guest count for each day, to get the most accurate insights possible.",
            "no_days_with_default_for_month": "There are no days with default values for {month}.",
            "monthly_average_for_date": "Monthly average for {date}",
            "date_already_exist": "Date already exist.",
            "based_on_default_guest_count": "Based on default guest count values.",
            "enter_real_guest_count": "Enter real guest count.",
            "success": "Guest count successfully updated"
        },
        "no_data": {
            "available": "No data available",
            "insufficent_data": "There is insufficient data for the selected time period. Please change the time period and try again!"
        },
        "error": {
            "please_try_again": "Something went wrong. Please try again.",
            "no_properties_assigned": "No property assigned to this user.",
            "no_image_after_filtering": {
                "default": "No images match the selected filters.",
                "incorrect_label_reported": "No incorrect labels have been reported.",
                "starred": "No images have been starred.",
                "noted": "No notes have been added."
            }
        },
        "items": {
            "all_categories": "All categories",
            "search_items": "Search items",
            "add_new_item": "Add new item",
            "item": "Item",
            "category": "Category",
            "price_kg": "Price / 1 kg",
            "item_added": "Item added",
            "last_edited": "Last edited",
            "view_price_history": "View price history",
            "edit_price": "Edit price",
            "current_price": "Current price",
            "selected_items": "Selected items",
            "new_price": "New price",
            "set_new_price": "Set new price",
            "add_period": "Add period",
            "price_history": "Price history",
            "price": "Price",
            "browse_items": "Browse items",
            "add_selected_items": "Add selected items",
            "cant_find_an_item": "Can’t find an item?",
            "request_a_new_addition": "Request an addition",
            "adding_new_price_period_warning_message": "If the time new period is overlapping with some other period from the price history, it will cause changes to the previous time periods.",
            "tracked_items": "Tracked items",
            "tracked_items_tip": "Tip: Drag and drop items to change order",
            "last_month": "Last month"
        },
        "service_times": {
            "open_closed_days": "Open / closed days",
            "set_days_when_open": "Set days when the outlet is regularly open",
            "show_past_opening_days": "Show past opening days",
            "hide_past_opening_days": "Hide past opening days",
            "set_new_opening_dates": "Set new opening dates",
            "set_exceptional_closing_dates": "Set exceptional closing dates (e.g. holidays, seasonal closure, etc.)",
            "closed": "Closed",
            "show_past_closing_days": "Show past closing days",
            "hide_past_closing_days": "Hide past closing days",
            "add_new_closing_period": "Add new closing period",
            "are_you_sure_to_save_changes": "Are you sure you would like to save changes?",
            "you_have_made_changes": "You’ve just made changes that significantly impact your past and future data and calculations.",
            "please_confirm": "Please confirm to make these changes.",
            "tip": "Hover over segments to see data per source",
            "out_of_service_time": "Out of service time",
            "period_filter_day": "Day total",
            "period_filter_week": "Week total",
            "period_filter_month": "Month total",
            "period_filter_year": "Year total",
            "dayParts": {
                "morning": "Morning",
                "midday": "Midday",
                "day": "Midday",
                "evening": "Evening"
            }
        },
        "sidebar": {
            "overview": "Overview",
            "best_practices": "Best practices",
            "categories": "Categories",
            "menus": "Dishes",
            "dashboard": "Dashboard",
            "my_goals": "My goals",
            "tracked_items": "Tracked items",
            "settings": "Settings",
            "help": "Help"
        },
        "tracked_items": {
            "my_tracked_items": "My tracked items",
            "select_items_to_track": "Select items to track",
            "current_savings_of_items_being_tracked": "Current savings of items being tracked",
            "tooltip_header": "Tooltip header",
            "tooltip_body": "Tooltip body",
            "set_monthly_goal": "Set monthly goal",
            "tracked_since": "Tracked since",
            "latest_trash_event_images": "Latest trash event images",
            "last_month_you_saved": "Last month you saved",
            "since_the_start_you_saved": "Since the start of tracking you saved",
            "reduction": "reduction",
            "your_current_montly_saving_goal": "Your current monthly savings goal is a",
            "percent": "percent",
            "monthly_savings": "Monthly savings",
            "your_reduction_goal": "Your reduction goal",
            "your_performance": "Your performance",
            "monthly_savings_goal": "Monthly waste limit",
            "first_month_tracked": "First month tracked",
            "target_monthly_waste": "Target monthly waste with this goal",
            "current_items_tooltip_header": "Tracked items",
            "current_items_tooltip_paragraph_1": "With so much information at once, it is important to focus only on a few main items and have a clear plan of action.",
            "current_items_tooltip_paragraph_2": "Your tracked items are the items you have selected to focus on reducing. After adding an item to the tracking list, the previous 30 days from the day you've added it represent the \"baseline 30 days\" for this item. This baseline will act as the comparison to determine if there are reductions compared to the months that follow.",
            "current_items_tooltip_paragraph_3": "You can currently track up to 5 items. Once you have achieved your goal for an item you can switch it out for a new one.",
            "single_tracked_item_tooltip_header": "Monthly goal",
            "single_tracked_item_tooltip_paragraph_1": "To drive reductions, it is important to focus on your key problem areas and set goals. We recommend starting with a 20% item reduction goal.",
            "single_tracked_item_tooltip_paragraph_2": "To calculate your progress, we look at how much you reduce your monthly kg of food waste in comparison to your baseline period. This baseline was set automatically when you added an item to the tracking list. You've reached your target when the blue and the green bar align. That's when you can set a new goal!",
            "savings": "Tracked Items Savings",
            "savings_subtitle": "Data is shown for all items tracked for over 60 days, until the last calendar month's end",
            "avg_wpg_reduction": "Avg WPG Reductions",
            "avg_cpg_reduction": "Avg CPG Reductions",
            "last_month": "Last month",
            "highest": "Highest",
            "savings_to_date": "Savings to date",
            "365_days_projection": "365 day projection",
            "365_days_tooltip": "This shows the projected savings value looking at your daily average savings multiplied by 365 days",
            "current_items_tracked": "Current items being tracked",
            "current_items_tracked_tooltip": "This list shows savings achieved for all the items that are being tracked. Change the status to filter this view.",
            "weight": "Weight",
            "cost": "Cost",
            "wpg": "WPG",
            "difference": "Difference",
            "cpg": "CPG",
            "365_days_saving": "365 day saving",
            "status": "Status",
            "actively_tracked": "Actively tracked",
            "hidden": "Hidden",
            "pending": "Pending",
            "stopped": "Stopped",
            "all": "All",
            "select_tracked_items": "Select items to track",
            "tracking_start": "Tracking start",
            "coming_soon": "Coming soon! As soon as you have made savings your performance overview will be visible here!",
            "check_back": "Check back in soon to see how much you’ve saved.",
            "current_waste_per_guest": "Current waste per guest",
            "waste_during_baseline_dates": "Waste per guest during baseline dates",
            "for_the_month": "For the month MM of YYYY compared to baseline",
            "current_wpg": "Current WPG",
            "current_cpg": "Current CPG",
            "baseline": "Baseline",
            "total_measured": "Total measured",
            "avg_wpg": "Average waste per guest",
            "reduced_by": "Reduce by",
            "monthly_goal": "Monthly goal",
            "action_implemented": "Action implemented",
            "action_implemented_on": "Implemented on",
            "action_implemented_on_tooltip": "The date at which you have started implementing this action in your operations",
            "action_targeted_results": "Targeted results",
            "action_targeted_results_tooltip": "Cumulative savings if the reduction goal was achieved every months since the tracked baseline",
            "action_achieved_results": "Achieved results",
            "action_achieved_results_tooltip": "Cumulative savings you have achieved in comparison to the tracked baseline",
            "action_delete": "Delete action",
            "action_edit": "Edit action",
            "action_new": "New action",
            "item_insight_tracker": "Item insight tracker",
            "item_insight_tracker_tooltip": "These are the discovered insights for this item looking at the 30 days of data before the date indicated below. These insights are updated every 30 days.",
            "iit_based_on": "Based on averages since being tracked",
            "iit_last_updated_on": "Last updated on",
            "iit_day_patterns": "Day patterns",
            "iit_day_patterns_tooltip": "Average day with most waste & average weight amount wasted per day",
            "iit_trashevent_frequency": "Trash event frequency",
            "iit_trashevent_frequency_tooltip": "Average number of times this item was thrown away and at what weight amount",
            "iit_at": "at",
            "iit_main_source": "Main source",
            "iit_main_source_tooltip": "Which source the majority of this item was wasted from",
            "iit_expected_next_month": "Expected next month",
            "iit_expected_next_month_tooltip": "Daily amount of waste (or %CURRENCY%) captured multiplied by the number of non-closed days in the coming month",
            "iit_loss_in_365_days": "Loss in 365 days if no action is taken",
            "iit_loss_in_365_days_tooltip": "Daily amount of waste cost captured multiplied by 365 days",
            "iit_savings_in_365_days": "Savings in 365 days with 30% reduction",
            "iit_savings_in_365_days_tooltip": "(Daily amount of waste cost captured multiplied by 365 days) multiplied by 30%",
            "iit_notes": "Notes",
            "actions_tracked_since": "This item is being tracked since",
            "actions_data_visible": "Data will be visible 60 days after tracking start.",
            "actions_check_back": "Check back in then to set an action.",
            "add_tracked_item": "Add tracked item",
            "add_tracked_item_tip": "The date you select will determine as of when \nthis item will be tracked. This means that it will show \ndata on your tracked items page from that date on.",
            "add_tracked_item_baseline": "Will be the first 30 days from the date \nselected below.",
            "start_tracking_as_of": "Start tracking as of",
            "stop_tracked_item": "Stop tracking item",
            "stop_tracked_item_tip": "The date you select will determine as of when you will stop tracking this item. The savings made will still appear in your overall performance but the item will not be visible as a individual item on the tracked items page.",
            "stop_tracking_as_of": "Stop tracking as of",
            "stop_tracking": "Stop tracking",
            "avg_wpg_reduction_tooltip": "Average weight % savings of all tracked items over entire duration during which the item was actively tracked",
            "avg_cpg_reduction_tooltip": "Average cost % savings of all tracked items over entire duration during which the item was actively tracked",
            "savings_to_date_tooltip": "Total weight savings of all tracked items over entire duration during which the item was actively tracked",
            "current_waste_per_guest_tooltip": "This shows the items performance over the last complete month of data in relation to your entered guest count",
            "monthly_savings_goal_tooltip_header": "Monthly savings goal",
            "monthly_savings_goal_tooltip": "This graph shows you the month to month waste per guest amount, where the baseline is highlighted in red and your percentage goal set is represented by the green line",
            "avg_wpg_tooltip": "Shows the average performance of the item over the entire tracking period in relation to entered the guest count",
            "set_an_action": "Set an action",
            "type_action": "Type action…",
            "start_action_as_of": "Start action as of",
            "action_type": "Action type",
            "action_type_other": "Other",
            "action_type_equipment_change": "Equipment/plate/container change",
            "action_type_improve_qc": "Improving quality control",
            "action_type_menu_change": "Menu/recipe change",
            "action_type_recirculate": "Recirculating to another area",
            "action_type_reduce_portion": "Reduce portion size",
            "action_type_reduce_volume": "Reduce production volume",
            "action_type_remove_item": "Remove item from offering",
            "action_type_style_change": "Serving style change",
            "action_type_training": "Staffing training/change",
            "action_type_storage_change": "Storage change",
            "action_type_supplier_change": "Supplier change",
            "action_type_repurpose": "Transform/repurpose",
            "action_type_guest_communication": "Guest communication",
            "action_type_donated_externally": "Donated externally",
            "action_type_donated_internally": "Donated internally",
            "confirm_irreversible_action": "Warning: Are you sure you want to delete this action? This action cannot be undone."
        },
        "filters_period": {
            "day": "Day",
            "week": "Week",
            "month": "Month",
            "year": "Year"
        },
        "tooltips": {
            "waste": {
                "text1": "Waste type",
                "text2": "Edible",
                "text3": "Refers to all food items for human consumption.",
                "text4": "Inedible",
                "text5": "Parts of food items that are normally not meant for human consumption such as egg shells, bones and vegetable peels."
            }
        },
        "filters_waste": {
            "all": "All",
            "avoidable": "Edible",
            "unavoidable": "Inedible"
        },
        "filters_device": {
            "all": "All"
        },
        "filters_compare_day": {
            "day_before": "Day before",
            "same_day_week_before": "Same day week before",
            "average_day": "Average day",
            "base_day": "Base Day"
        },
        "filters_compare_week": {
            "previous_week": "Previous week",
            "average_week": "Average week",
            "base_week": "Base week"
        },
        "filters_compare_month": {
            "previous_month": "Previous month",
            "average_month": "Average month",
            "base_month": "Base month"
        },
        "filters_compare_year": {
            "previous_year": "Previous year"
        },
        "navbar": {
            "period": "Period",
            "compare_to": "Compare to",
            "waste_type": "Waste type",
            "device": "Device",
            "date": "Date",
            "logout": "Log out",
            "set_items_to_track": "Set items to track",
            "save_report": "Print report",
            "unsupported_settings": "Unsupported print settings",
            "dates": "Dates"
        },
        "auth": {
            "welcome": "Welcome!",
            "lets_save": "Let's save food together!",
            "password": "Password",
            "login_button": "Login",
            "forgot_password": "Forgot password?",
            "are_you_sure": "Are you sure?",
            "yes": "Yes",
            "no": "No",
            "log_out_text": "You will be logged out from this page.",
            "email": "Email",
            "enter_email": "Enter email",
            "forgot_button": "Send reset instructions",
            "forgot_password_text": "Enter the email address you used when you joined and we'll send you instructions to reset your password.",
            "back_to_login": "Go to login page",
            "not_valid_email_for_forgot_password": "The email address does not seem to be valid. Please check the inputted email address and try again.",
            "forgot_password_success": "We have sent you an email with further instructions.",
            "reset_password": "Reset your password",
            "reset_password_text": "Please enter and confirm your new password",
            "reset_password_button": "Reset password",
            "reset_password_repeat": "Repeat new password",
            "new_password": "New password",
            "password_success": "Your password has been successfully changed!",
            "success": "Success!",
            "attention": "Attention",
            "ok": "OK",
            "no_account": "Don't have an account? Get started today!"
        },
        "category_listing": {
            "total": "Total",
            "category_listing_explanation": "Categories of Waste",
            "categories_of_waste": "Categories of Waste",
            "view_images": "View Images",
            "load_more_button": "Load More",
            "category_service_times_tooltip": "Hover over the bar to see the service period and the corresponding percentage of waste."
        },
        "support": {
            "title": "Are you having trouble?",
            "paragraph": "Let us know what the issue is and we’ll get back to you shortly.",
            "type_message": "Type message here",
            "thank_you": "Thank you for letting us know!",
            "select_issue_type": "Select issue type",
            "other": "Other",
            "mistake_in_the_data": "Mistake in the data",
            "data_is_not_loading": "Data is not loading",
            "technical_problems_with_the_dashboard": "Technical problems with the dashboard",
            "technical_problems_with_the_hardware": "Technical problems with the hardware",
            "back_to_dashboard": "Back to Dashboard",
            "send": "Send",
            "see_more_images": "Want to see more images?",
            "request_more_images": "Request additional images.",
            "info_message": "Your issue was successfully reported. We will get back to you as soon as possible."
        },
        "radio_toggler": {
            "serviceTime": "Service time",
            "source": "Source"
        },
        "overview": {
            "from": "from",
            "top_wasted_menu_items": "Top 5 wasted dish items",
            "top_wasted_categories": "Top 5 wasted categories",
            "explore_menus": "Explore Dishes",
            "explore_categories": "Explore Categories",
            "edible_vs_inedible_waste": "Edible vs. inedible waste",
            "sources_of_edible_waste": "Sources of edible waste",
            "over_selected_time_period": "Over selected time period",
            "selected_time_period": "Selected time period",
            "hover_to_see_different_sources": "Hover over segments to see % for different sources",
            "average_waste_per_guest_per_day": "Average waste per guest per day",
            "waste_per_guest_per_service_time": "Waste per guest per service time",
            "since_the_base_month_of": "Since the base month of",
            "total_you_have_saved": "Total you have saved",
            "trash_event_images": "Top wasted items - trash event images",
            "trash_event_images_tip": "Only single-labeled events with large waste amounts are shown",
            "tip_hover_over_columns": "Hover over columns to see more information",
            "hover_over_peaks_to_see_more_information": "Hover over peaks to see more information",
            "total_tooltip_header": "Total savings",
            "total_tooltip_subheader": "How are savings calculated?",
            "total_tooltip_paragraph_1": "The total savings compare how much you wasted in CHF and kg every month compared to the initial waste levels measured during your baseline period (first 30 days after starting the measurement). Every month, we check if the new total is lower than the baseline total and cumulate the difference resulting in your total savings.",
            "pax_entered": "Guests",
            "graph_view": "Graph view",
            "table_view": "Table view",
            "reference_line": "Comparison period average",
            "time": {
                "day_before": "Day before",
                "same_day_week_before": "Same day week before",
                "average_day": "Average day",
                "base_day": "Base day",
                "previous_week": "Previous week",
                "average_week": "Average week",
                "base_week": "Base week",
                "previous_month": "Previous month",
                "average_month": "Average month",
                "base_month": "Base month"
            },
            "from_time": {
                "day_before": "From day before",
                "same_day_week_before": "From same day week before",
                "average_day": "From average day",
                "base_day": "From base day",
                "previous_week": "From previous week",
                "average_week": "From average week",
                "base_week": "From base week",
                "previous_month": "From previous month",
                "average_month": "From average month",
                "base_month": "From base month"
            }
        },
        "legend": {
            "date_selected": "Date selected",
            "date_unavailable": "Data unavailable (processing)",
            "date_future": "Date is in the future"
        },
        "toggle_legend": {
            "late_night": "Late night",
            "morning": "Morning",
            "day": "Midday",
            "evening": "Evening",
            "production": "Overproduction",
            "plate": "Plate",
            "preparation": "Preparation"
        },
        "tooltips_content": {
            "source_of_waste": {
                "title": "Source of waste",
                "content": "This is determined based on multiple variables:",
                "dash1": "- location of the KITRO device",
                "dash2": "- time the trash event occured",
                "dash3": "- whether the item is considered avoidabe or unavoidable",
                "dash4": "- the weight"
            },
            "service_time": {
                "title": "Service times",
                "row1": "Morning: 3:30 - 10:59",
                "row2": "Midday: 11:00 - 16:59",
                "row3": "Evening: 17:00 - 3:29"
            }
        },
        "custom_validation": {
            "closed_days": {
                "required": "Select at least one day."
            }
        },
        "special_cases": {
            "peak_title_all": "All waste over time",
            "peak_title_avoidable": "Edible waste over time",
            "peak_title_unavoidable": "Inedible waste over time",
            "waste_cost_all": "Total waste cost",
            "waste_cost_avoidable": "Edible waste cost",
            "waste_cost_unavoidable": "Inedible waste cost",
            "waste_weight_all": "Total waste weight",
            "waste_weight_avoidable": "Edible waste weight",
            "waste_weight_unavoidable": "Inedible waste weight",
            "waste_per_guest_all": "Waste per guest",
            "waste_per_guest_avoidable": "Edible waste per guest",
            "waste_per_guest_unavoidable": "Inedible waste per guest",
            "waste_per_guest_cost_all": "Cost per guest",
            "waste_per_guest_cost_avoidable": "Edible cost per guest",
            "waste_per_guest_cost_unavoidable": "Inedible cost per guest",
            "sources_of_waste_all": "Sources of all waste",
            "sources_of_waste_avoidable": "Sources of edible waste",
            "sources_of_waste_unavoidable": "Sources of inedible waste",
            "waste_service_times_all": "All waste - service times",
            "waste_service_times_avoidable": "Edible waste - service times",
            "waste_service_times_unavoidable": "Inedible waste - service times",
            "waste_per_category_over_time_all": "All waste per category over time",
            "waste_per_category_over_time_avoidable": "Edible waste per category over time",
            "waste_per_category_over_time_unavoidable": "Inedible waste per category over time"
        },
        "stats_card": {
            "waste_weight": "waste weight",
            "waste_cost": "waste cost",
            "waste_per_guest": "Waste per guest",
            "meals_saved": "Meals saved",
            "for_day": "On the selected day",
            "for_period": "Over selected time period",
            "from_beginning_measurements": "From the beginning of measurement"
        },
        "trashevent": {
            "report_incorrect_label": "Report incorrect label",
            "incorrect_label_reported": "Incorrect label reported",
            "report_incorrect_label_modal_text": "Please let us know what the correct label should have been",
            "download": "Download",
            "note": "Note",
            "write_a_note": "Write a note here",
            "write_correct_label": "Write correct label here",
            "star": "Star",
            "starred": "Starred",
            "filter_all": "All",
            "filter_starred": "Starred",
            "filter_noted": "With notes",
            "filter_incorrect_label_reported": "Incorrect label reported",
            "filter_top_5_wasted_items": "Top 5 wasted items",
            "order_timestamp": "Most recent first",
            "order_weight": "Highest weight first"
        },
        "my_goals": {
            "baseline_dates_are": "Baseline dates are",
            "change_baseline_dates": "Change baseline dates",
            "pick_starting_date_for_baseline": "Pick a starting date for your baseline period. We will automatically select the next 30 days during which waste data was recorded (this maybe more than 30 calendar days).",
            "what_are_baseline_dates": "What are baseline dates?",
            "baseline_date_represent": "Baseline dates represent an initial period of time during which we measured your food waste to establish a standard amount of waste, against which we can compare your performance over time.",
            "we_only_recommend": "We only recommend you change your baseline dates if the initial time period is not representative of your normal waste level due to extraordinary circumstances.",
            "results_based_on": "Results shown based on",
            "edible_waste": "edible waste",
            "results_calculated_until": "Results calculated until",
            "in_total_you_have_saved": "In total you have saved",
            "since_last_month": "since last month",
            "per_guest_you_have_saved": "Per guest you have saved",
            "total_guest_savings": "Total guest savings",
            "weight": "Weight",
            "cost": "Cost",
            "tracking_started": "Tracking started",
            "change": "Change",
            "tracked_items_over_time": "Tracked items over time",
            "food_waste_code_vs_food_cost": "Food waste cost vs. food cost",
            "enter_monthly_food_cost": "Enter monthly food cost",
            "food_cost": "Food cost",
            "food_waste_cost": "Food waste cost",
            "baseline_food_cost": "Baseline food cost",
            "baseline_food_waste_cost": "Baseline food waste cost",
            "monthly_food_cost": "Monthly food cost",
            "enter_your_total_food_cost": "Enter how much your total food cost was in the past months",
            "monthly_savings": "Monthly savings",
            "average_monthly_savings": "Average monthly savings",
            "average_reduction": "average reduction",
            "expected_annual_savings": "Expected annual savings (based on average)",
            "expected_savings_for": "expected savings for 1 year",
            "coming_soon": "Your goals page will become visible after we have defined your waste reduction goals and after the first 60 days of measurement.",
            "monthly_savings_tooltip_header": "Tracked goal",
            "monthly_savings_tooltip_paragraph_1": "To drive reductions and results, it is important to set goals and implement action plans. We recommend starting with a 20% reduction goal.",
            "monthly_savings_tooltip_paragraph_2": "To calculate your progress, we look at how much you reduce your monthly kg of food waste in comparison to the 30 days since you started tracking this item. This baseline was set automatically when you added an item to the tracking list. You've reached your target when the blue and the green bar align. That's when you can set a new goal!",
            "baseline_results_are": "Baseline results are",
            "and": "and",
            "total_savings": "Total savings",
            "wpg": "WPG",
            "meals": "meals",
            "calculation_multipliers": "Calculation multipliers",
            "calculation_multipliers_text": "These multipliers are used to determine a average meals saved and CO2 produced.",
            "meals_saved": "Meals saved",
            "set_multipliers": "Currently set multiplier",
            "per_guest": "per guest",
            "avg_set": "Avg. set",
            "per_kg": "per kg",
            "per_meal": "per meal"
        },
        "month": {
            "january": "January",
            "february": "February",
            "march": "March",
            "april": "April",
            "may": "May",
            "june": "June",
            "july": "July",
            "august": "August",
            "september": "September",
            "october": "October",
            "november": "November",
            "december": "December"
        },
        "notifications": {
            "new": "New",
            "earlier": "Earlier",
            "notifications": "Notifications",
            "no_notifications": "No notifications",
            "load_more": "Load more",
            "end_of_feed": "End of feed"
        },
        "relative_times": {
            "seconds": "s",
            "minutes": "m",
            "hours": "h",
            "days": "d",
            "months": "m",
            "years": "y"
        }
    },
    "de": {
        "global": {
            "cancel": "Abbrechen",
            "save": "Speichern",
            "closed": "Geschlossen",
            "confirm": "Bestätigen",
            "discard": "Verwerfen",
            "unsaved_changes_discard_them": "Sie haben ungespeicherte Änderungen! Wollen Sie sie verwerfen?",
            "remove": "Entfernen",
            "add": "Hinzufügen",
            "loading": "Daten werden geladen. Bitte warten...",
            "tip": "Hinweis",
            "item": "Artikel",
            "date_time": "Datum Zeit",
            "cost": "Kosten",
            "weight": "Gewicht",
            "see_more": "Mehr",
            "see_less": "Weniger",
            "learn_more": "Mehr erfahren",
            "over_time": "Zeitstrahl",
            "filter": "Filter",
            "order": "Sortieren",
            "all": "Alles",
            "no_more_data": "Keine Daten verfügbar",
            "try_again": "Nochmals versuchen",
            "hide": "Weniger",
            "warning": "Achtung",
            "save_changes": "Änderungen speichern",
            "baseline": "Referenzperiode",
            "beforeMeasStart": "Vor Beginn der Messung",
            "invalid_date": "Ungültiges Datum"
        },
        "time": {
            "now": "Jetzt",
            "from": "Von",
            "to": "Bis",
            "start_date": "Anfang",
            "end_date": "Ende"
        },
        "days": {
            "monday": "Montag",
            "tuesday": "Dienstag",
            "wednesday": "Mittwoch",
            "thursday": "Donnerstag",
            "friday": "Freitag",
            "saturday": "Samstag",
            "sunday": "Sonntag"
        },
        "settings": {
            "settings": "Einstellungen",
            "guest_count": "Gästeanzahl",
            "inventory": "Inventar",
            "service_times": "Servicezeiten",
            "start_date_exists": "Anfangsdatum bereits verwendet"
        },
        "guest_count": {
            "last_edited_by": "<b>Zuletzt verändert</b> von {name} am {date}",
            "default_value": "Standardwert",
            "global_default_value": "Standardwert",
            "monthly_default_value": "Monatlicher Standardwert",
            "show_days_with_default_value": "Tage mit Standardwert anzeigen",
            "set_default_values": "Standardwerte eingeben",
            "set_global_default_values": "Standardwerte eingeben",
            "set_monthly_default_values": "Monatliche Standardwerte eingeben",
            "data_entry_settings": "Einstellungen für die Dateneingabe",
            "date": "Datum",
            "morning": "Morgen",
            "midday": "Tag",
            "midday_secondary": "Mittag",
            "evening": "Abend",
            "total": "Gesamt",
            "default": "Standard",
            "if_global_guest_count_is_not_enter": "Wenn Sie diese neue Standardzahl speichern, werden alle früheren Einträge und leeren Felder durch die neue Standardzahl ersetzt.",
            "please_enter_global_guest_count": "Bitte geben Sie die durchschnittliche Anzahl der täglich bedienten Gäste ein:",
            "if_monthly_guest_count_is_not_enter": "Wenn Sie diese Zahl speichern, werden nur die Felder des aktuell angezeigten Monats angepasst.",
            "please_enter_monthly_guest_count": "Bitte geben Sie die durchschnittliche Anzahl der Gäste pro Tag für den ausgewählten Monat ein:",
            "warning_global": "Achtung! Wenn Sie dies ändern, werden alle zuvor eingegebenen Zahlen für alle Nutzer überschrieben!",
            "warning_monthly": "Achtung! Wenn Sie diese Zahl ändern, werden alle zuvor eingegebenen Zahlen in diesem Monat für alle Nutzer seit Beginn der Messungen überschrieben!",
            "guest_count_data_entry": "Eingabe der Gästeanzahl",
            "enter_actual_or_average": "Möchten Sie die tatsächliche Anzahl der Gäste pro Tag oder einen Monatsdurchschnitt eingeben?",
            "per_day": "Pro Tag",
            "monthly_average_only": "Monatsdurchschnitt",
            "default_values": "Standardwerte",
            "what_are_they": "Was bedeuted das?",
            "default_values_are_automatically_put": "Standardwerte werden automatisch in die Zellen eingesetzt, die Sie leer gelassen haben. Sie dienen dazu, Ihnen ungefähre Statistiken zu liefern, auch wenn Sie nicht in allen Zellen Ihre tatsächliche Gästeanzahl eingegeben haben.",
            "recommend_enter_guest_count": "Wir empfehlen Ihnen, immer Ihre tatsächliche Gästezahl für jeden Tag einzugeben, um einen möglichst genauen Einblick zu erhalten.",
            "no_days_with_default_for_month": "Es gibt keine Tage mit Standardwerten für {Monat}.",
            "monthly_average_for_date": "Monatsdurchschnitt für {Datum}",
            "date_already_exist": "Diese Datum ist bereits vorhanden.",
            "based_on_default_guest_count": "Basierend auf den Standardwerten für die Gästeanzahl.",
            "enter_real_guest_count": "Gib hier die tatsächliche Gästeanzahl ein.",
            "success": "Gästeanzahl aktualisiert"
        },
        "no_data": {
            "available": "Keine Daten verfügbar",
            "insufficent_data": "Für den ausgewählten Zeitraum liegen keine ausreichenden Daten vor. Bitte ändere den Zeitraum und versuche es erneut!"
        },
        "error": {
            "please_try_again": "Es ist etwas schief gelaufen, bitte noch einmal versuchen.",
            "no_properties_assigned": "Diesem Kunden ist kein Benutzer zugeordnet.",
            "no_image_after_filtering": {
                "default": "Es passen keine Bilder in die Filterauswahl.",
                "incorrect_label_reported": "Es wurden noch keine falschen Identifikationen gemeldet.",
                "starred": "Es wurden noch keine Favoriten hinzugefügt.",
                "noted": "Es wurden noch keine Notizen erfasst."
            }
        },
        "items": {
            "all_categories": "Alle Kategorien",
            "search_items": "Artikel suchen",
            "add_new_item": "Neuer Artikel hinzufügen",
            "item": "Artikel",
            "category": "Kategorie",
            "price_kg": "Preis / 1 kg",
            "item_added": "Artikel hinzugefügt",
            "last_edited": "Zuletzt bearbeitet",
            "view_price_history": "Preisverlauf anzeigen",
            "edit_price": "Preis bearbeiten",
            "current_price": "Aktueller Preis",
            "selected_items": "Ausgewählte Artikel",
            "new_price": "Neuer Preis",
            "set_new_price": "Neuen Preis festlegen",
            "add_period": "Zeitraum hinzufügen",
            "price_history": "Preisverlauf",
            "price": "Preis",
            "browse_items": "Artikel durchsuchen",
            "add_selected_items": "Ausgewählte Artikel hinzufügen",
            "cant_find_an_item": "Sie können einen Artikel nicht finden?",
            "request_a_new_addition": "Ergänzung anfordern",
            "adding_new_price_period_warning_message": "Wenn sich der neue Zeitraum mit einem anderen Zeitraum aus dem Preisverlauf überschneidet, führt dies zu Änderungen an den vorherigen Zeiträumen.",
            "tracked_items": "Gespeicherte Artikel",
            "tracked_items_tip": "Hinweis: Ziehen und Ablegen von Artikeln zur Änderung der Reihenfolge",
            "last_month": "Letzter Monat"
        },
        "service_times": {
            "open_closed_days": "Offen / geschlossene Tage",
            "set_days_when_open": "Tage festlegen, an denen der Betrieb regelmässig geöffnet ist",
            "show_past_opening_days": "Vergangene Öffnungszeiten anzeigen",
            "hide_past_opening_days": "Vergangene Öffnungszeiten ausblenden",
            "set_new_opening_dates": "Neue Öffnungzeiten festlegen",
            "set_exceptional_closing_dates": "Aussergewöhnliche Daten, an denen der Betrieb geschlossen bleibt (z.B. Feiertage, Saisonschliessung usw.)",
            "closed": "Geschlossen",
            "show_past_closing_days": "Vergangene Ruhetage anzeigen",
            "hide_past_closing_days": "Vergangene Ruhetage ausblenden",
            "add_new_closing_period": "Neue Daten hinzufügen",
            "are_you_sure_to_save_changes": "Sind Sie sicher, dass Sie Änderungen speichern möchten?",
            "you_have_made_changes": "Sie haben gerade Änderungen vorgenommen, die sich erheblich auf Ihre vergangenen und zukünftigen Daten und Berechnungen auswirken.",
            "please_confirm": "Bitte bestätigen Sie, diese Änderungen vorzunehmen.",
            "tip": "Fahre mit der Maus über die Abschnitte, um die Daten pro Ursache anzuzeigen.",
            "out_of_service_time": "Ausserhalb der definierten Servicezeiten",
            "period_filter_day": "Tag total",
            "period_filter_week": "Woche total",
            "period_filter_month": "Monat total",
            "period_filter_year": "Jahr total",
            "dayParts": {
                "morning": "Morgen",
                "midday": "Mittag",
                "day": "Mittag",
                "evening": "Abend"
            }
        },
        "sidebar": {
            "overview": "Übersicht",
            "best_practices": "Massnahmen",
            "categories": "Kategorien",
            "menus": "Gerichteübersicht",
            "dashboard": "Dashboard",
            "my_goals": "Deine Leistung",
            "tracked_items": "Gespeicherte Artikel",
            "settings": "Einstellungen",
            "help": "Hilfe"
        },
        "tracked_items": {
            "my_tracked_items": "Meine getrackten Artikel",
            "select_items_to_track": "Artikel wählen und speichern",
            "current_savings_of_items_being_tracked": "Aktuelle Einsparungen der getrackten Artikel",
            "tooltip_header": "Tooltip-Kopfzeile",
            "tooltip_body": "Tooltip-Körper",
            "set_monthly_goal": "Monatliches Ziel festlegen",
            "tracked_since": "Beobachtet seit",
            "latest_trash_event_images": "Neuste Bilder",
            "last_month_you_saved": "Einsparung im letzten Monat",
            "since_the_start_you_saved": "Einsparungen seit Beginn der Beobachtung",
            "reduction": "Reduzierung",
            "your_current_montly_saving_goal": "Aktuelles monatliches Sparziel",
            "percent": "Prozent",
            "monthly_savings": "Monatliche Einsparungen",
            "your_reduction_goal": "Ihr Reduktionsziel",
            "your_performance": "Deine Leistung",
            "monthly_savings_goal": "Monatliches Abfalllimit",
            "first_month_tracked": "Referenzmonat",
            "target_monthly_waste": "Monatliche Verschwendung mit diesem Sparziel",
            "current_items_tooltip_header": "Gespeicherte Artikel",
            "current_items_tooltip_paragraph_1": "Bei so vielen Informationen auf einmal ist es wichtig, sich zuerst auf 1-5 Zutaten zu konzentrieren und einen klaren Aktionsplan zu haben.",
            "current_items_tooltip_paragraph_2": "Die gespeicherten Artikel sind die Zutaten, welche von euch ausgewählt wurden mit dem Ziel diese während einer gewissen Zeit zu beobachten und eine Reduktion zu erzielen. \nNachdem Ihr einen Artikel gespeichert habt, wird automatisch eine Referenzmenge erstellt. Diese ist die Summe der Abfallsmenge während 30 Tage vor dem Tag, an dem der Artikel in die Liste aufgenommen wurde.\nDiese Referenz dient als Massstab, um festzustellen, ob es im Vergleich zu den kommenden Monaten eine Reduzierung gibt.",
            "current_items_tooltip_paragraph_3": "Ihr könnt bis zu 5 Artikel speichern. Sobald Ihr euer Ziel für einen Artikel erreicht habt, könnt Ihr diesen gegen einen neuen Artikel austauschen.",
            "single_tracked_item_tooltip_header": "Monatsziel",
            "single_tracked_item_tooltip_paragraph_1": "Um gute Resultate zu erzielen, ist es wichtig, sich in erster Linie auf Hauptproblembereiche zu konzentrieren und Ziele zu setzen. Wir empfehlen, mit einem Reduktionsziel von 20% zu beginnen.",
            "single_tracked_item_tooltip_paragraph_2": "Um den Fortschritt zu berechnen, vergleichen wir die monatliche Reduktion (kg) von Lebensmittelabfälle zur Referenzmenge. Diese Referenzmenge wird automatisch festgelegt, wenn ein Artikel gespeichert wird. Wenn der blaue und der grüne Balken übereinstimmen, habt Ihr euer Ziel erreicht. Das ist der Zeitpunkt, an dem Ihr euch ein neues Ziel setzen könnt!",
            "savings": "Einsparungen der getrackten Artikel",
            "savings_subtitle": "Die Daten werden für alle getrackten Artikel seit mehr als 60 Tagen bis zum Ende des letzten Kalendermonats angezeigt",
            "avg_wpg_reduction": "Durchschnittliche WPG-Reduktion",
            "avg_cpg_reduction": "Durchschnittliche CPG-Reduktion",
            "last_month": "Letzter Monat",
            "highest": "Höchster",
            "savings_to_date": "Einsparungen bis heute",
            "365_days_projection": "365-Tage-Projektion",
            "365_days_tooltip": "Hier wird der prognostizierte Sparwert angezeigt, der sich aus den durchschnittlichen täglichen Einsparungen multipliziert mit 365 Tagen ergibt.",
            "current_items_tracked": "Aktuell getrackte Artikel",
            "current_items_tracked_tooltip": "Diese Liste zeigt die erzielten Einsparungen für alle Artikel, die getrackt werden. Ändere den Status, um diese Ansicht zu filtern.",
            "weight": "Gewicht",
            "cost": "Kosten",
            "wpg": "Abfall pro Gast",
            "difference": "Differenz",
            "cpg": "Kosten pro Gast",
            "365_days_saving": "365-Tage-Einsparung",
            "status": "Status",
            "actively_tracked": "Aktiv getrackt",
            "hidden": "Versteckt",
            "pending": "Ausstehend",
            "stopped": "Gestoppt",
            "all": "Alle",
            "select_tracked_items": "Zu trackende Artikel auswählen",
            "tracking_start": "Getrackt seit",
            "coming_soon": "Demnächst! Sobald Ersparnisse erzielt wurden, wird die Leistungsübersicht hier sichtbar sein!",
            "check_back": "Schau bald wieder rein, um zu sehen, wie viel gespart wurde.",
            "current_waste_per_guest": "Aktueller Abfall pro Gast",
            "waste_during_baseline_dates": "Abfall pro Gast in der Referenzperiode",
            "for_the_month": "Für den Monat MM in YYYY im Vergleich zur Referenzperiode",
            "current_wpg": "Aktueller Abfall pro Gast",
            "current_cpg": "Aktuelle Kosten pro Gast",
            "baseline": "Referenzperiode",
            "total_measured": "Insgesamt gemessen",
            "avg_wpg": "Durchschnittlicher Abfall pro Gast",
            "reduced_by": "Reduzieren um",
            "monthly_goal": "Monatliches Ziel",
            "action_implemented": "Eingeführte Massnahmen",
            "action_implemented_on": "Eingeführt am",
            "action_implemented_on_tooltip": "Das Datum, an dem mit der Umsetzung dieser Maßnahme im Betrieb begonnen wurde",
            "action_targeted_results": "Angestrebte Ergenisse",
            "action_targeted_results_tooltip": "Kumulative Einsparungen, wenn das Ziel der Abfallreduzierung in jedem Monat seit der getrackten Referenzperiode erreicht wurde",
            "action_achieved_results": "Erreichte Ergebnisse",
            "action_achieved_results_tooltip": "Kumulierte Einsparungen, die im Vergleich zur getrackten Referenzperiode erzielt wurden",
            "action_delete": "Massnahme löschen",
            "action_edit": "Massnahme ändern",
            "action_new": "Neue Massnahme",
            "item_insight_tracker": "Artikel-Tracker",
            "item_insight_tracker_tooltip": "Dies sind die ermittelten Erkenntnisse für diesen Artikel, die sich auf die 30 Tage vor dem unten angegebenen Datum beziehen. Diese Erkenntnisse werden alle 30 Tage aktualisiert.",
            "iit_based_on": "Basierend auf Durchschnittswerten seit dem Tracking",
            "iit_last_updated_on": "Zuletzt aktualisiert am",
            "iit_day_patterns": "Tagesmuster",
            "iit_day_patterns_tooltip": "Durchschnittlicher Tag mit den meisten Abfällen und durchschnittlicher Gewichtsmenge pro Tag",
            "iit_trashevent_frequency": "Häufigkeit von Abfallereignissen",
            "iit_trashevent_frequency_tooltip": "Wie oft wurde dieser Aritkel durchschnittlich weggeworfen und mit welchem Gewicht",
            "iit_at": "bei",
            "iit_main_source": "Hauptquelle",
            "iit_main_source_tooltip": "Aus welcher Quelle wurde der größte Teil dieses Aritkels weggeworfen",
            "iit_expected_next_month": "Erwartungen nächster Monat",
            "iit_expected_next_month_tooltip": "Täglich erfasste Abfallmenge (oder %CURRENCY%) multipliziert mit der Anzahl der nicht geschlossenen Tage im kommenden Monat",
            "iit_loss_in_365_days": "Verlust in 365 Tagen, wenn keine Massnahmen ergriffen werden",
            "iit_loss_in_365_days_tooltip": "Täglicher Betrag der erfassten Abfallkosten multipliziert mit 365 Tagen",
            "iit_savings_in_365_days": "Einsparungen in 365 Tagen bei einer Reduzierung um 30%",
            "iit_savings_in_365_days_tooltip": "(Tägliche Menge der erfassten Abfallkosten multipliziert mit 365 Tagen) multipliziert mit 30%",
            "iit_notes": "Notizen",
            "actions_tracked_since": "Dieser Artikel wird getrackt seit",
            "actions_data_visible": "Die Daten werden 60 Tage nach Beginn des Trackings sichtbar sein.",
            "actions_check_back": "Schau später noch einmal rein, um Massnahmen festzulegen.",
            "add_tracked_item": "Zu trackende Artikel hinzufügen",
            "add_tracked_item_tip": "Das von Ihnen gewählte Datum bestimmt, ab wann \ndieser Artikel getrackt wird. Ab diesem Datum werden die Daten für den ausgewählten Artikel angezeigt",
            "add_tracked_item_baseline": "Die ersten 30 Tage ab dem unten gewählten Datum.",
            "start_tracking_as_of": "Beginne tracking ab",
            "stop_tracked_item": "Stop das tracking",
            "stop_tracked_item_tip": "Das ausgewählte Datum bestimmt, ab wann Sie diesen Artikel nicht mehr tracken. Die erzielten Einsparungen werden weiterhin in Ihrer Gesamtleistung angezeigt, jedoch wird der Artikel nicht mehr als Artikel auf der Seite für getrackte Artikel erscheinen.",
            "stop_tracking_as_of": "Stop das tracking ab",
            "stop_tracking": "Tracking stoppen",
            "avg_wpg_reduction_tooltip": "Durchschnittliche prozentuale Gewichtseinsparung aller getrackten Artikel über den gesamten Zeitraum, in dem der Artikel aktiv getrackt wurde",
            "avg_cpg_reduction_tooltip": "Durchschnittliche prozentuale Kosteneinsparung aller getrackten Artikel über die gesamte Dauer, in der der Artikel aktiv getrackt wurde",
            "savings_to_date_tooltip": "Gesamtgewichtseinsparungen aller getrackten Artikel während der gesamten Dauer, in der der Artikel aktiv getrackt wurde",
            "current_waste_per_guest_tooltip": "Hier wird die Performance der Artikel im letzten Monat in Bezug auf die eingegebene Gästezahl angezeigt.",
            "monthly_savings_goal_tooltip_header": "Monatliches Sparziel",
            "monthly_savings_goal_tooltip": "Dieses Diagramm zeigt den monatlichen Abfall pro Gast, wobei der Ausgangswert rot hervorgehoben ist und das prozentuale Ziel durch die grüne Linie dargestellt wird.",
            "avg_wpg_tooltip": "Dies zeigt die durchschnittliche Leistung des Artikels über den gesamten Messzeitraum im Verhältnis zur eingegebenen Gästezahl",
            "set_an_action": "Lege eine Massnahme fest",
            "type_action": "Massnahme eingeben...",
            "start_action_as_of": "Start der Massnahme ab",
            "action_type": "Art der Massnahme",
            "action_type_other": "Andere",
            "action_type_equipment_change": "Wechsel von Tellern/Schüsseln/Behältnissen",
            "action_type_improve_qc": "Verbesserung der Qualitätskontrolle",
            "action_type_menu_change": "Menü/Rezeptänderung",
            "action_type_recirculate": "Rückführung in einen anderen Bereich",
            "action_type_reduce_portion": "Verkleinerung der Portionsgrösse",
            "action_type_reduce_volume": "Reduzierung der Produktionsmenge",
            "action_type_remove_item": "Artikel aus dem Angebot genommen",
            "action_type_style_change": "Änderung des Service",
            "action_type_training": "Schulung/Änderung des Personals",
            "action_type_storage_change": "Änderung der Lagerung",
            "action_type_supplier_change": "Wechsel des Lieferanten",
            "action_type_repurpose": "Umgestaltung/Wiederverwendug",
            "action_type_guest_communication": "Gästekommunikation",
            "action_type_donated_externally": "Extern gespendet",
            "action_type_donated_internally": "Intern gespendet",
            "confirm_irreversible_action": "Warnung: Sind Sie sicher, dass Sie diese Massnahme löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "filters_period": {
            "day": "Tag",
            "week": "Woche",
            "month": "Monat",
            "year": "Jahr"
        },
        "tooltips": {
            "waste": {
                "text1": "Abfallart",
                "text2": "Vermeidbar",
                "text3": "Bezieht sich auf alle Lebensmittel, die für den menschlichen Verzehr bestimmt sind.",
                "text4": "Unvermeidbar",
                "text5": "Teile von Lebensmitteln, die normalerweise nicht für den menschlichen Verzehr bestimmt sind (z.B. Eierschalen, Knochen und Gemüseschalen)."
            }
        },
        "filters_waste": {
            "all": "Beides",
            "avoidable": "Vermeidbar",
            "unavoidable": "Unvermeidbar"
        },
        "filters_device": {
            "all": "Gesamt"
        },
        "filters_compare_day": {
            "day_before": "Vorheriger Tag",
            "same_day_week_before": "Gleicher Tag letzte Woche",
            "average_day": "Durchschnittstag",
            "base_day": "Referenztag"
        },
        "filters_compare_week": {
            "previous_week": "Vorherige Woche",
            "average_week": "Durchschnittswoche",
            "base_week": "Referenzwoche"
        },
        "filters_compare_month": {
            "previous_month": "Vorheriger Monat",
            "average_month": "Durchschnittsmonat",
            "base_month": "Referenzmonat"
        },
        "filters_compare_year": {
            "previous_year": "Vorheriges Jahr"
        },
        "navbar": {
            "period": "Zeitabschnitt",
            "compare_to": "Vergleiche mit",
            "waste_type": "Abfallart",
            "device": "Gerät",
            "date": "Datum",
            "logout": "Ausloggen",
            "set_items_to_track": "Artikel wählen",
            "save_report": "Bericht drucken",
            "unsupported_settings": "Druckeinstellungen nicht verfügbar",
            "dates": "Daten"
        },
        "auth": {
            "welcome": "Willkommen!",
            "lets_save": "Gemeinsam gegen Food Waste",
            "password": "Passwort",
            "login_button": "Anmelden",
            "forgot_password": "Passwort vergessen?",
            "are_you_sure": "Sind Sie sicher?",
            "yes": "Ja",
            "no": "Nein",
            "log_out_text": "Sie werden von dieser Seite abgemeldet.",
            "email": "Email",
            "enter_email": "Email eingeben",
            "forgot_button": "Rückstellanweisungen senden",
            "forgot_password_text": "Um Ihr Passwort zurückzusetzen, geben Sie die E-Mail-Adresse ein, welche Sie bei der Anmeldung verwendet haben.",
            "back_to_login": "Zurück zur Loginseite",
            "not_valid_email_for_forgot_password": "Die E-Mail-Adresse scheint nicht gültig zu sein. Bitte die eingegebene E-Mail-Adresse überprüfen und erneut versuchen.",
            "forgot_password_success": "Eine Email mit weiteren Anweisungen ist auf dem Weg.",
            "reset_password": "Passwort zurücksetzen",
            "reset_password_text": "Bitte neues Passwort eingeben und bestätigen",
            "reset_password_button": "Passwort zurücksetzen",
            "reset_password_repeat": "Neues Passwort wiederholen",
            "new_password": "Neues Passwort",
            "password_success": "Das Passwort wurde erfolgreich geändert.",
            "success": "Erfolgreich",
            "attention": "Achtung",
            "ok": "Ok",
            "no_account": "Noch keinen Account? Jetzt Konto erstellen!"
        },
        "category_listing": {
            "total": "Total",
            "category_listing_explanation": "Abfallkategorien",
            "categories_of_waste": "Abfallkategorien",
            "view_images": "Bilder anschauen",
            "load_more_button": "Mehr",
            "category_service_times_tooltip": "Bewege den Mauszeiger über den Balken, um die Servicezeiten und den entsprechenden Prozentsatz des Abfalls zu sehen."
        },
        "support": {
            "title": "Benötigst du Hilfe?",
            "paragraph": "Sende uns dein Problem, damit wir dir helfen können.",
            "type_message": "Hier Nachricht eingeben",
            "thank_you": "Danke für Ihre Nachricht.",
            "select_issue_type": "Problem auswählen",
            "other": "Anderes",
            "mistake_in_the_data": "Fehler in den Daten",
            "data_is_not_loading": "Daten laden nicht",
            "technical_problems_with_the_dashboard": "Technisches Problem mit dem Dashboard",
            "technical_problems_with_the_hardware": "Technisches Problem mit dem Gerät",
            "back_to_dashboard": "Zurück zum Dashboard",
            "send": "Senden",
            "see_more_images": "Willst du mehr Bilder sehen? Dann klicke hier.",
            "request_more_images": "Fordern Sie zusätzliche Bilder an.",
            "info_message": "Das Problem wurde erfolgreich weitergeleitet. Wir werden uns so schnell wie möglich darum kümmern."
        },
        "radio_toggler": {
            "serviceTime": "Servicezeiten",
            "source": "Ursache"
        },
        "overview": {
            "from": "vom",
            "top_wasted_menu_items": "Top 5 meist verschwendete Artikel",
            "top_wasted_categories": "Top 5 Kategorien",
            "explore_menus": "Gerichte erforschen",
            "explore_categories": "Kategorien erforschen",
            "edible_vs_inedible_waste": "Vermeidbarer vs. unvermeidbarer Abfall",
            "sources_of_edible_waste": "Ursachen vermeidbare Abfälle",
            "over_selected_time_period": "Im gewählten Zeitraum",
            "selected_time_period": "Ausgewählte Zeitspanne",
            "hover_to_see_different_sources": "Fahre mit der Maus über die Abschnitte, um den prozentualen Anteil verschiedener Ursachen anzuzeigen.",
            "average_waste_per_guest_per_day": "Durchschnittlicher Abfall pro Gast pro Tag",
            "waste_per_guest_per_service_time": "Abfall pro Gast pro Servicezeit",
            "since_the_base_month_of": "Seit dem Referenzmonat",
            "total_you_have_saved": "Totale Einsparnisse",
            "trash_event_images": "Meist verschwendete Artikel - Bilder",
            "trash_event_images_tip": "Nur Ereignisse mit grösseren Mengen und einem Label werden angezeigt",
            "tip_hover_over_columns": "Fahren Sie mit dem Zeiger über die Spalten, um weitere Informationen anzuzeigen.",
            "hover_over_peaks_to_see_more_information": "Fahre mit der Maus über die Grafik, um weitere Informationen zu erhalten.",
            "total_tooltip_header": "Gesamteinsparungen",
            "total_tooltip_subheader": "Wie werden Einsparungen berechnet?",
            "total_tooltip_paragraph_1": "Die Gesamteinsparungen vergleichen, wie viel ihr jeden Monat in CHF und kg verschwendet habt, verglichen mit den anfänglichen Abfallmengen, die während der Referenzperiode (30 Tage nach Beginn der Messung) gemessen wurden. Jeden Monat überprüfen wir, ob die neue Gesamtsumme niedriger ist als die Ausgangssumme und kumulieren die Differenz, was zu euren Gesamteinsparungen führt.",
            "pax_entered": "Gästenanzahl",
            "graph_view": "Grafikansicht",
            "table_view": "Tabellenansicht",
            "reference_line": "Durchschnitt der Vergleichsperiode",
            "time": {
                "day_before": "vorherigem Tag",
                "same_day_week_before": "Gleicher Tag letzte Woche",
                "average_day": "Durchschnittstag",
                "base_day": "Referenztag",
                "previous_week": "der vorherigen Woche",
                "average_week": "Durchschnittswoche",
                "base_week": "der Referenzwoche",
                "previous_month": "vorherigen Monat",
                "average_month": "Durchschnittsmonat",
                "base_month": "Referenzmonat"
            },
            "from_time": {
                "day_before": "Zum vorherigen Tag",
                "same_day_week_before": "Zum gleichen Tag letzter Woche",
                "average_day": "Zum Durchschnittstag",
                "base_day": "Zum Referenztag",
                "previous_week": "Zur vorherigen Woche",
                "average_week": "Zur Durchschnittswoche",
                "base_week": "Zur Referenzwoche",
                "previous_month": "Vom vorherigen Monat",
                "average_month": "Zum Durchschnittsmonat",
                "base_month": "vom Referenzmonat"
            }
        },
        "legend": {
            "date_selected": "Ausgewähltes Datum",
            "date_unavailable": "Daten nicht verfügbar",
            "date_future": "Datum ist in der Zukunft"
        },
        "toggle_legend": {
            "late_night": "Nacht",
            "morning": "Morgen",
            "day": "Mittag",
            "evening": "Abend",
            "production": "Überproduktion",
            "plate": "Tellerrückläufe",
            "preparation": "Vorbereitung"
        },
        "tooltips_content": {
            "source_of_waste": {
                "title": "Abfallsursache",
                "content": "Die Abfallsursache wird anhand folgender Punkte ermittelt:",
                "dash1": "- Gerätestandort (Küche vs. Abwasch)",
                "dash2": "- Entsorgungszeit",
                "dash3": "- Art des Artikels: vermeidbar / unvermeidbar",
                "dash4": "- Gewicht"
            },
            "service_time": {
                "title": "Servicezeiten total",
                "row1": "Morgen: 3:30 - 10:59",
                "row2": "Mittag: 11:00 - 16:59",
                "row3": "Abend: 17:00 - 3:29"
            }
        },
        "custom_validation": {
            "closed_days": {
                "required": "Mindestens einen Tag auswählen"
            }
        },
        "special_cases": {
            "peak_title_all": "Gesamtleistung",
            "peak_title_avoidable": "Gesamtleistung - vermeidbare Abfälle",
            "peak_title_unavoidable": "Gesamtleistung - unvermeidbare Abfälle",
            "waste_cost_all": "Gesamtkosten",
            "waste_cost_avoidable": "Vermeidbare Kosten",
            "waste_cost_unavoidable": "Unvermeidbare Kosten",
            "waste_weight_all": "Gesamte Abfallmenge",
            "waste_weight_avoidable": "Vermeidbare Abfallmenge",
            "waste_weight_unavoidable": "Unvermeidbare Abfallmenge",
            "waste_per_guest_all": "Abfall pro Gast",
            "waste_per_guest_avoidable": "Vermeidbarer Abfall pro Gast",
            "waste_per_guest_unavoidable": "Unvermeidbarer Abfall pro Gast",
            "waste_per_guest_cost_all": "Kosten pro Gast",
            "waste_per_guest_cost_avoidable": "Vermeidbare Kosten pro Gast",
            "waste_per_guest_cost_unavoidable": "Unvermeidbare Kosten pro Gast",
            "sources_of_waste_all": "Abfallursachen total",
            "sources_of_waste_avoidable": "Vermeidbare Abfallursachen",
            "sources_of_waste_unavoidable": "Unvermeidbare Abfallsursachen",
            "waste_service_times_all": "Servicezeiten total",
            "waste_service_times_avoidable": "Servicezeiten - vermeidbarer Abfall",
            "waste_service_times_unavoidable": "Servicezeiten - unvermeidbarer Abfall",
            "waste_per_category_over_time_all": "Gesamtabfall pro Kategorie",
            "waste_per_category_over_time_avoidable": "Vermeidbarer Abfall pro Kategorie",
            "waste_per_category_over_time_unavoidable": "Unvermeidbarer Abfall pro Kategorie"
        },
        "stats_card": {
            "waste_weight": "Abfallsmenge",
            "waste_cost": "Abfallskosten",
            "waste_per_guest": "Abfall pro Gast",
            "meals_saved": "Mahlzeiten gerettet",
            "for_day": "Am gewählten Tag",
            "for_period": "Im gewählten Zeitraum",
            "from_beginning_measurements": "Seit Messbeginn"
        },
        "trashevent": {
            "report_incorrect_label": "Falsche Identifikation melden",
            "incorrect_label_reported": "Falsche Identifikation gemeldet",
            "report_incorrect_label_modal_text": "Bitte teile uns mit, was das richtige Label hätte sein sollen. Schreibe hier den richtigen Artikel",
            "download": "herunterladen",
            "note": "Hinweis",
            "write_a_note": "Schreibe hier eine Notiz",
            "write_correct_label": "Schreiben Sie hier den richtigen Artikel",
            "star": "zu Favoriten hinzufügen",
            "starred": "zu Favoriten hinzugefügt",
            "filter_all": "Alle",
            "filter_starred": "Favoriten",
            "filter_noted": "Mit Notizen",
            "filter_incorrect_label_reported": "Falsches Label gemeldet",
            "filter_top_5_wasted_items": "Top 5 der verschwendeten Artikel",
            "order_timestamp": "nach Datum (neustes zuerst)",
            "order_weight": "nach Gewicht (absteigend)"
        },
        "my_goals": {
            "baseline_dates_are": "Referenzperiode ist",
            "change_baseline_dates": "Referenzperiode ändern",
            "pick_starting_date_for_baseline": "Wählen Sie ein Startdatum für Ihre Referenzperiode. Wir wählen automatisch die nächsten 30 Tage aus, in denen Abfalldaten erfasst wurden (dies können mehr als 30 Kalendertage sein).",
            "what_are_baseline_dates": "Was bedeutet Referenzperiode?",
            "baseline_date_represent": "Der Referenzzeitraum steht für eine anfängliche Zeitperiode, in dem Ihre Lebensmittelabfälle gemessen weden um eine Standardabfallmenge festzulegen. Dies ermöglicht einen Vergleich zwischen den Anfangsmengen und den Verbesserungen im Laufe der Messzeit.",
            "we_only_recommend": "Wir empfehlen Ihnen Ihre Referenzperiode nur dann zu ändern, wenn der anfängliche Zeitraum aufgrund aussergewöhnlicher Umstände nicht repräsentativ für Ihre normale Abfallmenge ist.",
            "results_based_on": "Angezeigte Resultate basierend auf",
            "edible_waste": "vermeidbare Abfälle",
            "results_calculated_until": "Resultate berechnet bis",
            "in_total_you_have_saved": "Gesamt Ersparnisse",
            "since_last_month": "seit letztem Monat",
            "per_guest_you_have_saved": "Ersparnisse pro Gast",
            "total_guest_savings": "Einsparungen für Gäste insgesamt",
            "weight": "Gewicht",
            "cost": "Kosten",
            "tracking_started": "Beobachtung gestartet",
            "change": "Veränderung",
            "tracked_items_over_time": "Gespeicherte Artikel im Laufe der Zeit",
            "food_waste_code_vs_food_cost": "Kosten der Lebensmittelabfälle vs. Wareneinsatz",
            "enter_monthly_food_cost": "Monatlicher Wareneinsatz eingeben",
            "food_cost": "Wareneinsatz",
            "food_waste_cost": "Kosten der Lebensmittelabfälle",
            "baseline_food_cost": "Wareneinsatz während Referenzperiode",
            "baseline_food_waste_cost": "Abfallkosten während Referenzperiode",
            "monthly_food_cost": "Monatlicher Wareneinsatz",
            "enter_your_total_food_cost": "Geben Sie ein, wie hoch Ihre gesamten Lebensmittelkosten in den vergangenen Monaten waren",
            "monthly_savings": "Monatliche Einsparungen",
            "average_monthly_savings": "Durchschnittliche monatliche Einsparungen",
            "average_reduction": "durchschnittliche Reduzierung",
            "expected_annual_savings": "Erwartete jährliche Einsparungen (basierend auf dem Durchschnitt)",
            "expected_savings_for": "Erwartete Einsparungen für 1 Jahr",
            "coming_soon": "Deine Zielseite wird sichtbar, nachdem wir deine Ziele definiert haben und nach den ersten 60 Tagen der Messung",
            "monthly_savings_tooltip_header": "Monatsziel",
            "monthly_savings_tooltip_paragraph_1": "Um Reduktionen und Ergebnisse voranzutreiben, ist es wichtig, Ziele zu setzen und Aktionspläne umzusetzen. Wir empfehlen, mit einem Reduktionsziel von 20% zu beginnen.",
            "monthly_savings_tooltip_paragraph_2": "Um den Fortschritt zu berechnen, vergleichen wir die monatliche Reduktion (kg) von Lebensmittelabfälle mit den ersten 30 Tagen seit Beginn der Beobachtung dieses Artikels. Diese Referenzperiode wird automatisch gesetzt, sobald ein Artikel gespeichert wird.\nWenn der blaue und der grüne Balken übereinstimmen, habt ihr euer Ziel erreicht. Das ist der Zeitpunkt, an dem ihr euch ein neues Ziel setzen könnt!",
            "baseline_results_are": "Ergebnisse der Referenzperiode sind",
            "and": "und",
            "total_savings": "Gesamteinsparungen",
            "wpg": "APG",
            "meals": "Gerichte",
            "calculation_multipliers": "Multiplikatoren für die Berechnung",
            "calculation_multipliers_text": "Diese Multiplikatoren werden verwendet, um die durchschnittlich eingesparten Mahlzeiten und das erzeugte CO2 zu ermitteln.",
            "meals_saved": "Mahlzeiten gerettet",
            "set_multipliers": "Derzeit genutzter Multiplikator",
            "per_guest": "pro Gast",
            "avg_set": "Durchschn. Wert",
            "per_kg": "pro kg",
            "per_meal": "pro Mahlzeit"
        },
        "month": {
            "january": "Januar",
            "february": "Februar",
            "march": "März",
            "april": "April",
            "may": "Mai",
            "june": "Juni",
            "july": "Juli",
            "august": "August",
            "september": "September",
            "october": "Oktober",
            "november": "November",
            "december": "Dezember"
        },
        "notifications": {
            "new": "Neu",
            "earlier": "Davor",
            "notifications": "Benachrichtigungen",
            "no_notifications": "Keine Nachrichten",
            "load_more": "Mehr",
            "end_of_feed": "Ende der Liste"
        },
        "relative_times": {
            "seconds": "Sek.",
            "minutes": "Min.",
            "hours": "Std.",
            "days": "Tg.",
            "months": "M.",
            "years": "J."
        }
    },
    "fr": {
        "global": {
            "cancel": "Annuler",
            "save": "Sauvegarder",
            "closed": "Fermé",
            "confirm": "Confirmer",
            "discard": "Ignorer",
            "unsaved_changes_discard_them": "Vous avez des changements non sauvegardés ! Souhaitez-vous les supprimer ?",
            "remove": "Supprimer",
            "add": "Ajouter",
            "loading": "Patience, les données sont en cours de chargement...",
            "tip": "Astuce",
            "item": "Article",
            "date_time": "Date Heure",
            "cost": "Coût",
            "weight": "Poids",
            "see_more": "En savoir plus",
            "see_less": "Moins montrer",
            "learn_more": "En savoir plus",
            "over_time": "Au fil du temps",
            "filter": "Filtrer",
            "order": "Ordre",
            "all": "Tout",
            "no_more_data": "Plus de donnée",
            "try_again": "Essayer à nouveau",
            "hide": "Ne plus montrer",
            "warning": "Attention",
            "save_changes": "Sauvegarder les changements",
            "baseline": "Période de référence",
            "beforeMeasStart": "Avant le début des mesures",
            "invalid_date": "Date invalide"
        },
        "time": {
            "now": "Maintenant",
            "from": "De",
            "to": "Jusqu'à",
            "start_date": "Début",
            "end_date": "Fin"
        },
        "days": {
            "monday": "Lundi",
            "tuesday": "Mardi",
            "wednesday": "Mercredi",
            "thursday": "Jeudi",
            "friday": "Vendredi",
            "saturday": "Samedi",
            "sunday": "Dimanche"
        },
        "settings": {
            "settings": "Réglages",
            "guest_count": "Nombre de clients",
            "inventory": "Inventaire",
            "service_times": "Heures de service",
            "start_date_exists": "La date de début est déjà utilisée"
        },
        "guest_count": {
            "last_edited_by": "<b>Dernier changement</b> par {name} le {date}",
            "default_value": "Valeur par défaut",
            "global_default_value": "Valeur globale par défaut",
            "monthly_default_value": "Valeur mensuelle par défaut",
            "show_days_with_default_value": "Afficher les jours avec valeurs par défaut",
            "set_default_values": "Définir les valeurs par défaut",
            "set_global_default_values": "Définir les valeurs par défaut globales",
            "set_monthly_default_values": "Définir les valeurs par défaut mensuelles",
            "data_entry_settings": "Paramètres de saisie des données",
            "date": "Date",
            "morning": "Matinée",
            "midday": "Journée",
            "midday_secondary": "Midi",
            "evening": "Soir",
            "total": "Total",
            "default": "Défaut",
            "if_global_guest_count_is_not_enter": "Toutes les entrées précédentes et les champs vides seront remplacés par cette nouvelle valeur par défaut.",
            "please_enter_global_guest_count": "Veuillez saisir le nombre de couverts servis en moyenne par jour :",
            "if_monthly_guest_count_is_not_enter": "La sauvegarde de ce nombre modifiera uniquement les valeurs du mois affiché.",
            "please_enter_monthly_guest_count": "Veuillez saisir le nombre de couverts servis en moyenne par jour pour le mois sélectionné :",
            "warning_global": "Attention ! La modification de cette valeur remplacera tous les chiffres précédemment saisis par les membres de votre équipe depuis le début des mesures !",
            "warning_monthly": "Attention ! La modification de ce chiffre remplacera tous les chiffres précédemment saisis par les membres de votre équipe pour le mois affiché !",
            "guest_count_data_entry": "Saisir le nombre de clients",
            "enter_actual_or_average": "Par défaut, souhaitez-vous entrer le nombre réel de clients par jour ou seulement une moyenne mensuelle ?",
            "per_day": "Par jour",
            "monthly_average_only": "Moyenne mensuelle",
            "default_values": "Valeur par défaut.",
            "what_are_they": "Quelles sont-elles?",
            "default_values_are_automatically_put": "Les valeurs par défaut sont automatiquement enregistrées dans les cellules que tu as laissées vides. Elles sont utilisées pour te donner des statistiques approximatives même si tu n'as pas saisi le nombre réel de clients dans toutes les cellules.",
            "recommend_enter_guest_count": "Nous recommandons de toujours entrer le nombre réel de clients journalier, afin d'obtenir les analyses les plus précises possible.",
            "no_days_with_default_for_month": "Il n'y a pas de jours avec des valeurs par défaut pour {mois}.",
            "monthly_average_for_date": "Moyenne mensuelle pour {date}",
            "date_already_exist": "Cette date existe déjà.",
            "based_on_default_guest_count": "Basé sur les valeurs par défaut du nombre de clients",
            "enter_real_guest_count": "Entre ton nombre de couvert réel",
            "success": "Nombre de couvert actualisé"
        },
        "no_data": {
            "available": "Pas de données disponibles",
            "insufficent_data": "Il n'y a pas suffisamment de données pour la période sélectionnée. Modifie la période et réessaie"
        },
        "error": {
            "please_try_again": "Une erreur s'est produite. Veuiller réessayer.",
            "no_properties_assigned": "Aucune propriété n’est assignée à cet utilisateur.",
            "no_image_after_filtering": {
                "default": "Aucune image pour les filtres selectionnés.",
                "incorrect_label_reported": "Aucune image incorrecte signalée.",
                "starred": "Aucune image dans les favoris.",
                "noted": "Aucune note ajoutée."
            }
        },
        "items": {
            "all_categories": "Toutes les catégories",
            "search_items": "Rechercher un article",
            "add_new_item": "Ajouter un article",
            "item": "Article",
            "category": "Catégorie",
            "price_kg": "prix / 1kg",
            "item_added": "Article ajouté",
            "last_edited": "Dernière modification",
            "view_price_history": "Voir l'historique des prix",
            "edit_price": "Modifier le prix",
            "current_price": "Prix actuel",
            "selected_items": "Articles sélectionnés",
            "new_price": "Nouveau prix",
            "set_new_price": "Définir un nouveau prix",
            "add_period": "Ajouter une période",
            "price_history": "Historique des prix",
            "price": "Prix",
            "browse_items": "Parcourir les articles",
            "add_selected_items": "Ajouter les articles sélectionnés",
            "cant_find_an_item": "Vous ne trouvez pas un article ?",
            "request_a_new_addition": "Demander un ajout",
            "adding_new_price_period_warning_message": "Si la nouvelle période chevauche une autre période de l'historique des prix, elle entraînera des changements par rapport aux périodes précédentes.",
            "tracked_items": "Articles suivis",
            "tracked_items_tip": "Conseil: Glisser-déposer des éléments pour changer l'ordre des articles",
            "last_month": "Mois dernier"
        },
        "service_times": {
            "open_closed_days": "Jour ouvert / fermé",
            "set_days_when_open": "Fixer les jours où le point de vente est régulièrement ouvert",
            "show_past_opening_days": "Afficher les jours d'ouverture passés",
            "hide_past_opening_days": "Ne pas montrer les jours d'ouverture passés",
            "set_new_opening_dates": "Fixer de nouvelles dates d'ouverture",
            "set_exceptional_closing_dates": "Fixer les dates de fermeture exceptionnelles (vacances, jours fériés)",
            "closed": "Fermé",
            "show_past_closing_days": "Montrer les dates de fermeture passées",
            "hide_past_closing_days": "Ne pas montrer les dates de fermeture passées",
            "add_new_closing_period": "Ajouter des nouvelles dates de fermeture",
            "are_you_sure_to_save_changes": "Êtes-vous sûr de vouloir sauvegarder ces changements ?",
            "you_have_made_changes": "Vous venez d'effectuer des changements qui ont un impact significatif sur vos données, vos calculs passés et futurs.",
            "please_confirm": "Veuillez confirmer ces changements.",
            "tip": "Survole avec ta souris sur les segments pour voir les pourcentages des différentes sources",
            "out_of_service_time": "En dehors des heures de service",
            "period_filter_day": "Journée totale",
            "period_filter_week": "Semaine totale",
            "period_filter_month": "Mois total",
            "period_filter_year": "Année totale",
            "dayParts": {
                "morning": "Matin",
                "midday": "Journée",
                "day": "Journée",
                "evening": "Soir"
            }
        },
        "sidebar": {
            "overview": "Vue d'ensemble",
            "best_practices": "Réduire mon gaspillage",
            "categories": "Catégories",
            "menus": "Plats",
            "dashboard": "Tableau de bord",
            "my_goals": "Mes objectifs",
            "tracked_items": "Articles suivis",
            "settings": "Paramètres",
            "help": "Aide"
        },
        "tracked_items": {
            "my_tracked_items": "Mes articles suivis",
            "select_items_to_track": "Sélectionner les articles à suivre",
            "current_savings_of_items_being_tracked": "Réduction actuelle des articles suivis",
            "tooltip_header": "En-tête de l'info-bulle",
            "tooltip_body": "Corps de l'info-bulle",
            "set_monthly_goal": "Fixer un objectif mensuel",
            "tracked_since": "Suivi depuis",
            "latest_trash_event_images": "Dernière photo prise",
            "last_month_you_saved": "Le mois dernier vous avez épargné",
            "since_the_start_you_saved": "Depuis le début du suivi, vous avez épargné",
            "reduction": "réduction",
            "your_current_montly_saving_goal": "Ton objectif d'épargne mensuel actuel est de",
            "percent": "pourcent",
            "monthly_savings": "Épargne mensuelle",
            "your_reduction_goal": "Votre objectif de réduction",
            "your_performance": "Ta performance",
            "monthly_savings_goal": "Limite de gaspillage mensuel",
            "first_month_tracked": "Premier mois de suivi",
            "target_monthly_waste": "Attaquez-vous à votre gaspillage mensuel avec cet objectif",
            "current_items_tooltip_header": "Articles suivis",
            "current_items_tooltip_paragraph_1": "Avec autant d'informations à la fois, il est important de se concentrer d'abord sur 1 à 5 ingrédients et de mettre en place un plan d'action.",
            "current_items_tooltip_paragraph_2": "Vos articles suivis sont les articles que vous avez sélectionnés avec le but de les observer pendant un certain temps et de les réduire. Après avoir ajouté un article à la liste de suivi, les 30 jours précédents à partir du jour où vous l'avez ajouté représentent les \"30 jours de base\" pour cet article. Cette base de référence servira de comparaison pour déterminer s'il y a une réduction par rapport aux mois suivants.",
            "current_items_tooltip_paragraph_3": "Vous pouvez suivre jusqu'à 5 articles. Une fois que vous avez atteint votre objectif pour un article, vous pouvez l'échanger contre un nouvel article.",
            "single_tracked_item_tooltip_header": "Objectif mensuel",
            "single_tracked_item_tooltip_paragraph_1": "Pour obtenir de bons résultats, il est important de se concentrer sur les sources problématiques principales et de se fixer des objectifs. Nous recommandons de commencer avec un objectif de réduction de 20%.",
            "single_tracked_item_tooltip_paragraph_2": "Pour calculer vos progrès, nous comparons la réduction mensuelle (kg) des déchets alimentaires à la quantité de référence. Cette quantité de référence est fixée automatiquement lors de la sauvegarde d'un article. Si les barres bleues et vertes correspondent, vous avez atteint votre objectif. C'est le moment où vous pouvez vous fixer un nouvel objectif !",
            "savings": "Réduction sur les articles suivis",
            "savings_subtitle": "Prend en compte tous les aliments suivis depuis plus de 60 jours j'usqu'à la fin du dernier mois",
            "avg_wpg_reduction": "Réduction moyenne de la perte par couvert",
            "avg_cpg_reduction": "Réduction moyenne du coût par couvert",
            "last_month": "Mois dernier",
            "highest": "Le plus haut",
            "savings_to_date": "Epargnes à ce jour",
            "365_days_projection": "Projection à 365 jours",
            "365_days_tooltip": "Montre la valeur des épargnes projetées en regardant votre économie moyenne quotidienne multipliée par 365 jours",
            "current_items_tracked": "Articles actuellement suivis",
            "current_items_tracked_tooltip": "Cette liste montre la réduction réalisée pour tous les articles qui sont suivis. Changez le statut pour filtrer cette vue",
            "weight": "Poid",
            "cost": "Coût",
            "wpg": "Perte par couvert",
            "difference": "Différence",
            "cpg": "Coût par couvert",
            "365_days_saving": "365 jours d'épargne",
            "status": "Statuts",
            "actively_tracked": "Suivi actif",
            "hidden": "Caché",
            "pending": "En cours",
            "stopped": "Terminé",
            "all": "Tous",
            "select_tracked_items": "Sélectionner les articles à suivre",
            "tracking_start": "Début du suivi",
            "coming_soon": "Patience! Dès que tu auras épargné, tu pourras voir ta performance ici!",
            "check_back": "Reviens bientôt afin de voir combien tu as épargné.",
            "current_waste_per_guest": "Perte par couvert actuelle",
            "waste_during_baseline_dates": "Perte par couvert pendant les dates de référence",
            "for_the_month": "Pour le mois MM de YYYY en comparaison avec la période de référence",
            "current_wpg": "Perte par couvert actuelle",
            "current_cpg": "Coût par couvert actuel",
            "baseline": "Période de référence",
            "total_measured": "Volume total mesuré",
            "avg_wpg": "Moyenne de la perte par couvert",
            "reduced_by": "Réduit de",
            "monthly_goal": "Objectif mensuel",
            "action_implemented": "Action implémentée",
            "action_implemented_on": "Implémentée le",
            "action_implemented_on_tooltip": "Date à laquelle cette action a été implémentée opérationnellement",
            "action_targeted_results": "Résultats ciblés",
            "action_targeted_results_tooltip": "Epargnes cumulées si l'objectif de réduction était atteint chaque mois depuis la période de référence définie",
            "action_achieved_results": "Résultats atteints",
            "action_achieved_results_tooltip": "Epargnes cumulées réalisées par rapport à la période de référence définie",
            "action_delete": "Action supprimée",
            "action_edit": "Editer l'action",
            "action_new": "Nouvelle action",
            "item_insight_tracker": "Aperçu des articles",
            "item_insight_tracker_tooltip": "Informations observées pour cet article basé sur les 30 jours de données avant la date indiquée ci-dessous. Ces informations sont mises à jour tous les 30 jours.",
            "iit_based_on": "Basé sur les moyennes depuis le début du suivi",
            "iit_last_updated_on": "Dernière mise à jour le",
            "iit_day_patterns": "Récurrences journalières",
            "iit_day_patterns_tooltip": "Jour enregistrant la moyenne de déchets la plus haute et quantité moyenne de poids gaspillé par jour",
            "iit_trashevent_frequency": "Fréquence à laquelle les aliments sont jetés",
            "iit_trashevent_frequency_tooltip": "Nombre moyen de fois où cet article a été jeté et le poids moyen à chaque fois",
            "iit_at": "à",
            "iit_main_source": "Source principale",
            "iit_main_source_tooltip": "À partir de quelle source la majorité de cet article a été gaspillée",
            "iit_expected_next_month": "Prévu pour le mois prochain",
            "iit_expected_next_month_tooltip": "La quantité quotidienne de déchets (ou %CURRENCY%) capturée multipliée par le nombre de jours non fermés dans le mois à venir",
            "iit_loss_in_365_days": "Perte dans les 365 jours si aucune mesure n'est prise",
            "iit_loss_in_365_days_tooltip": "Montant quotidien des coûts de déchets capturés multiplié par 365 jours",
            "iit_savings_in_365_days": "Epargne en 365 jours avec une réduction de 30%",
            "iit_savings_in_365_days_tooltip": "Montant quotidien des coûts de déchets capturés multiplié par 365 jours multiplié par 30%",
            "iit_notes": "Notes",
            "actions_tracked_since": "Cet aliment est traqué depuis le",
            "actions_data_visible": "Les données seront visibles 60 jours après le début du suivi",
            "actions_check_back": "Reviens dans quelques jours pour définir une actions",
            "add_tracked_item": "Ajouter des articles à suivre",
            "add_tracked_item_tip": "La date sélectionnée déterminera à partir de quand cet article sera suivi. Par conséquent, les données seront affichées sur votre page à partir de cette date.",
            "add_tracked_item_baseline": "Les 30 premiers jours à partir de la date sélectionnée ci-dessous.",
            "start_tracking_as_of": "Début du suivi à partir du",
            "stop_tracked_item": "Arrêter le suivi d'un article",
            "stop_tracked_item_tip": "La date sélectionnée déterminera à partir de quand l'arrêt du suivi de cet article sera effectif. Les économies réalisées continueront à apparaître dans la performance globale, mais l'article ne sera pas visible individuellement sur la page des articles suivis.",
            "stop_tracking_as_of": "Fin du suivi à partir du",
            "stop_tracking": "Arrêter le suivi",
            "avg_wpg_reduction_tooltip": "Le poids moyen % épargné pour tous les articles suivis sur la durée pendant laquelle ils ont été suivis activement",
            "avg_cpg_reduction_tooltip": "Réduction moyenne % réalisée sur le coût de tous les articles suivis sur la durée pendant laquelle l'article a été suivi activement",
            "savings_to_date_tooltip": "Réduction totale de poids de tous les articles suivis sur toute la durée pendant laquelle l'article a été activement suivi",
            "current_waste_per_guest_tooltip": "Montre la performance des articles sur le dernier mois complet de données par rapport au nombre de couverts saisi",
            "monthly_savings_goal_tooltip_header": "Perte moyenne par couvert",
            "monthly_savings_goal_tooltip": "Ce graphique  montre le montant de déchets par couvert d'un mois à l'autre, où la ligne de base est mise en évidence en rouge et l'objectif en pourcentage est représenté par la ligne verte",
            "avg_wpg_tooltip": "Montre la performance moyenne de l'article sur l'ensemble de la période de suivi par rapport au nombre de couverts saisi",
            "set_an_action": "Implémenter une action",
            "type_action": "Types d'actions",
            "start_action_as_of": "Début de l'action à partir du",
            "action_type": "Type d'action",
            "action_type_other": "Autre",
            "action_type_equipment_change": "Changer l'équipement, le plat, le contenant",
            "action_type_improve_qc": "Améliorer la qualité du contrôle",
            "action_type_menu_change": "Changer les menus, les recettes",
            "action_type_recirculate": "Améliorer la circularité entre les outlets",
            "action_type_reduce_portion": "Réduire la taille des portions",
            "action_type_reduce_volume": "Réduire le volume de production",
            "action_type_remove_item": "Retirer le produit de l'offre",
            "action_type_style_change": "Modifier le type de service",
            "action_type_training": "Améliorer la formation du personnel",
            "action_type_storage_change": "Modifier le stockage",
            "action_type_supplier_change": "Changer de fournisseur",
            "action_type_repurpose": "Transformer",
            "action_type_guest_communication": "Communication client",
            "action_type_donated_externally": "Dons à l'externe",
            "action_type_donated_internally": "Dons à l'interne",
            "confirm_irreversible_action": "Avertissement: Êtes-vous sûr de vouloir supprimer cette action ? Cette action est irréversible."
        },
        "filters_period": {
            "day": "Journée",
            "week": "Semaine",
            "month": "Mois",
            "year": "Année"
        },
        "tooltips": {
            "waste": {
                "text1": "Type de déchets",
                "text2": "Consommable",
                "text3": "Désigne tous les aliments destinés à la consommation humaine.",
                "text4": "Non consommable",
                "text5": "Parties d'aliments qui ne sont normalement pas destinées à la consommation humaine, comme les coquilles d'œufs, les os et les épluchures de légumes."
            }
        },
        "filters_waste": {
            "all": "Tout",
            "avoidable": "Consommable",
            "unavoidable": "Non consommable"
        },
        "filters_device": {
            "all": "Tout"
        },
        "filters_compare_day": {
            "day_before": "Jour précédent",
            "same_day_week_before": "Le même jour la semaine d'avant",
            "average_day": "Jour moyen",
            "base_day": "Jour de référence"
        },
        "filters_compare_week": {
            "previous_week": "Semaine précédente",
            "average_week": "Semaine moyenne",
            "base_week": "Semaine de référence"
        },
        "filters_compare_month": {
            "previous_month": "Mois précédent",
            "average_month": "Mois moyen",
            "base_month": "Mois de référence"
        },
        "filters_compare_year": {
            "previous_year": "Année précédente"
        },
        "navbar": {
            "period": "Période",
            "compare_to": "Comparer avec",
            "waste_type": "Type de déchets",
            "device": "Appareil",
            "date": "Date",
            "logout": "Déconnexion",
            "set_items_to_track": "Sélectionner les articles à suivre",
            "save_report": "Imprimer le rapport",
            "unsupported_settings": "Paramètres d'impression non pris en charge",
            "dates": "Dates"
        },
        "auth": {
            "welcome": "Bienvenue",
            "lets_save": "Ensemble contre le gaspillage alimentaire",
            "password": "Mot de passe",
            "login_button": "Se connecter",
            "forgot_password": "Mot de passe oublié",
            "are_you_sure": "Êtes-vous sûr?",
            "yes": "Oui",
            "no": "Non",
            "log_out_text": "Vous serez déconnecté de cette page.",
            "email": "Email",
            "enter_email": "Entrer un e-mail valide",
            "forgot_button": "Envoyer les instructions de réinitialisation",
            "forgot_password_text": "Entrez l'adresse e-mail que vous avez utilisé lors de l'inscription et nous vous enverrons des instructions pour réinitialiser votre mot de passe.",
            "back_to_login": "Retourner à la page de connexion",
            "not_valid_email_for_forgot_password": "E-mail invalide. Vérifiez l'adresse e-mail et réessaiez.",
            "forgot_password_success": "Nous vous avons envoyé un e-mail avec des instructions supplémentaires.",
            "reset_password": "Réinitialiser le mot de passe",
            "reset_password_text": "Valider et confirmer ton nouveau mot de passe",
            "reset_password_button": "Réinitialiser le mot de passe",
            "reset_password_repeat": "Répéter le nouveau mot de passe",
            "new_password": "Nouveau mot de passe",
            "password_success": "Votre mot de passe a été changé avec succès.",
            "success": "Succès",
            "attention": "Attention",
            "ok": "Ok",
            "no_account": "Pas encore de compte ? Créez un compte maintenant !"
        },
        "category_listing": {
            "total": "Total",
            "category_listing_explanation": "Catégories de déchet",
            "categories_of_waste": "Catégories de déchet",
            "view_images": "Voir les Images",
            "load_more_button": "Charger plus",
            "category_service_times_tooltip": "Survolez la barre pour afficher la période de service et le pourcentage de déchets correspondant"
        },
        "support": {
            "title": "Besoin d'un coup de main?",
            "paragraph": "Envoie-nous ton problème afin que nous puissions y apporter une solution",
            "type_message": "Entrez votre message ici",
            "thank_you": "Merci pour votre message.",
            "select_issue_type": "Choisir la catégorie de problèmes",
            "other": "Autre",
            "mistake_in_the_data": "Erreur dans les données",
            "data_is_not_loading": "Les données ne chargent pas",
            "technical_problems_with_the_dashboard": "Problème technique avec le tableau de bord",
            "technical_problems_with_the_hardware": "Problème technique avec l'appareil",
            "back_to_dashboard": "Retour au tableau de bord",
            "send": "Envoyer",
            "see_more_images": "Plus d'images?",
            "request_more_images": "Demander plus d’images.",
            "info_message": "Le problème a été envoyé avec succès. Nous nous en occuperons dès que possible."
        },
        "radio_toggler": {
            "serviceTime": "Heures d'ouverture",
            "source": "Source"
        },
        "overview": {
            "from": "de",
            "top_wasted_menu_items": "Top 5 plats gaspillés",
            "top_wasted_categories": "Top 5 catégories gaspillées",
            "explore_menus": "Explorer les plats",
            "explore_categories": "Explorer les catégories",
            "edible_vs_inedible_waste": "Consommable VS Non consommable",
            "sources_of_edible_waste": "Sources des déchets consommables",
            "over_selected_time_period": "Durant la période sélectionnée",
            "selected_time_period": "Période selectionnées",
            "hover_to_see_different_sources": "Survole avec ta souris sur les segments pour voir les pourcentages des différentes sources",
            "average_waste_per_guest_per_day": "Déchets moyens par client par jour",
            "waste_per_guest_per_service_time": "Déchets par client par service",
            "since_the_base_month_of": "Depuis la période de référence de",
            "total_you_have_saved": "Au total vous avez épargné",
            "trash_event_images": "Top des articles gaspillés en images",
            "trash_event_images_tip": "Seules les images avec un seul type de déchet et un poids élevé sont affichées",
            "tip_hover_over_columns": "Survolez la souris sur les colonnes pour voir plus d'informations",
            "hover_over_peaks_to_see_more_information": "Survolez les pics pour obtenir plus d'informations",
            "total_tooltip_header": "Économies totales",
            "total_tooltip_subheader": "Comment sont calculées les économies?",
            "total_tooltip_paragraph_1": "L'épargne totale est comparée à la quantité de déchets que vous avez gaspillée chaque mois en CHF et en kg par rapport aux quantités initiales de déchets mesurées pendant la période de référence (30 jours après le début de la mesure). Chaque mois, nous vérifions si le nouveau total est inférieur au total initial et nous cumulons la différence, ce qui donne le total de vos économies.",
            "pax_entered": "Clients",
            "graph_view": "Vue graphique",
            "table_view": "Vue tabulaire",
            "reference_line": "Moyenne sur la période de comparaison",
            "time": {
                "day_before": "Jour précédent",
                "same_day_week_before": "Le même jour la semaine d'avant",
                "average_day": "Jour moyen",
                "base_day": "Jour de référence",
                "previous_week": "Semaine précédente",
                "average_week": "Semaine moyenne",
                "base_week": "Semaine de référence",
                "previous_month": "Mois précédent",
                "average_month": "Mois moyen",
                "base_month": "Mois de référence"
            },
            "from_time": {
                "day_before": "Du jour précédent",
                "same_day_week_before": "Du même jour la semaine d'avant",
                "average_day": "Du jour moyen",
                "base_day": "Du jour de référence",
                "previous_week": "De la semaine précédente",
                "average_week": "De la semaine moyenne",
                "base_week": "De la semaine de référence",
                "previous_month": "Du mois précédent",
                "average_month": "Du mois moyen",
                "base_month": "par rapport au mois de référence"
            }
        },
        "legend": {
            "date_selected": "Date sélectionnée",
            "date_unavailable": "Données pas disponibles",
            "date_future": "Cette date est dans le futur"
        },
        "toggle_legend": {
            "late_night": "Nuit",
            "morning": "Matin",
            "day": "Journée",
            "evening": "Soir",
            "production": "Surproduction",
            "plate": "Retours d'assiettes",
            "preparation": "Préparation"
        },
        "tooltips_content": {
            "source_of_waste": {
                "title": "Source des déchets",
                "content": "La source des déchets est déterminée sur la base des points suivants :",
                "dash1": "- Placement de l'appareil (cuisine vs zone de débarassage)",
                "dash2": "- Moment où l'article est disposé",
                "dash3": "- Type d'article : consommable / non-consommable",
                "dash4": "- Poids"
            },
            "service_time": {
                "title": "Heures de service",
                "row1": "Matin: 3:30 - 10:59",
                "row2": "Journée: 11:00 - 16:59",
                "row3": "Soir: 17:00 - 3:29"
            }
        },
        "custom_validation": {
            "closed_days": {
                "required": "Sélectionnez au moins un jour"
            }
        },
        "special_cases": {
            "peak_title_all": "Performance globale",
            "peak_title_avoidable": "Performance - déchets consommable",
            "peak_title_unavoidable": "Performance - déchets non consommable",
            "waste_cost_all": "Coûts totaux",
            "waste_cost_avoidable": "Coûts des déchets consommables",
            "waste_cost_unavoidable": "Coûts des déchets non consommables",
            "waste_weight_all": "Volume des déchets",
            "waste_weight_avoidable": "Volume des déchets consommables",
            "waste_weight_unavoidable": "Volume des déchets non consommables",
            "waste_per_guest_all": "Déchets par client servi",
            "waste_per_guest_avoidable": "Déchets consommables par client servi",
            "waste_per_guest_unavoidable": "Déchets non consommables par repas servi",
            "waste_per_guest_cost_all": "Coût par client",
            "waste_per_guest_cost_avoidable": "Coût consommable par client",
            "waste_per_guest_cost_unavoidable": "Coût non-consommable par client",
            "sources_of_waste_all": "Source de déchets - total",
            "sources_of_waste_avoidable": "Source de déchets - consommable",
            "sources_of_waste_unavoidable": "Source de déchets - non consommable",
            "waste_service_times_all": "Heures de service - total",
            "waste_service_times_avoidable": "Heures de service - déchets consommables",
            "waste_service_times_unavoidable": "Heures de service - déchets non consommable",
            "waste_per_category_over_time_all": "Déchets total par catégorie",
            "waste_per_category_over_time_avoidable": "Déchets consommable par catégorie",
            "waste_per_category_over_time_unavoidable": "Déchets non consommable par catégorie"
        },
        "stats_card": {
            "waste_weight": "Volume des déchets",
            "waste_cost": "Coûts des déchets",
            "waste_per_guest": "Déchets par client",
            "meals_saved": "Repas épargnés",
            "for_day": "Durant le jour sélectionné",
            "for_period": "Durant la période sélectionnée",
            "from_beginning_measurements": "Depuis le début de l'analyse"
        },
        "trashevent": {
            "report_incorrect_label": "Signaler une identification incorrecte",
            "incorrect_label_reported": "Identification incorrecte reportée",
            "report_incorrect_label_modal_text": "Signaler une identification incorrecte\nIndique l'identification correcte",
            "download": "Télécharger",
            "note": "Note",
            "write_a_note": "Annoter",
            "write_correct_label": "Insère l'identification correcte ici",
            "star": "Ajouter au favoris",
            "starred": "Ajouté aux favoris",
            "filter_all": "Tout",
            "filter_starred": "Favoris",
            "filter_noted": "Annotées",
            "filter_incorrect_label_reported": "Identification incorrecte reportée",
            "filter_top_5_wasted_items": "Top 5 des articles gaspillés",
            "order_timestamp": "Plus récents",
            "order_weight": "Volume du plus élevé au plus bas"
        },
        "my_goals": {
            "baseline_dates_are": "La période de référence comprend",
            "change_baseline_dates": "Changer la période de référence",
            "pick_starting_date_for_baseline": "Choisissez une date de début pour votre période de référence. Nous sélectionnerons automatiquement les 30 jours suivants pendant lesquels les données sur les déchets ont été enregistrées (cela peut dépasser 30 jours civils).",
            "what_are_baseline_dates": "Que représente la période de référence?",
            "baseline_date_represent": "Les dates de référence représentent une période initiale pendant laquelle nous avons mesuré vos déchets alimentaires pour établir une quantité standard de gaspillage. Cette référence servira de comparaison pour vos économies du.",
            "we_only_recommend": "Nous vous recommandons de ne changer vos dates de référence que si la période initiale n'est pas représentative de votre niveau de déchets normal en raison de circonstances extraordinaires.",
            "results_based_on": "Les résultats indiqués sont basés sur",
            "edible_waste": "déchets consommables",
            "results_calculated_until": "Résultats calculés jusqu'au",
            "in_total_you_have_saved": "Au total tu as épargné",
            "since_last_month": "Depuis le mois dernier",
            "per_guest_you_have_saved": "Par client tu as épargné",
            "total_guest_savings": "Epargne totale par couvert",
            "weight": "Poids",
            "cost": "Coût",
            "tracking_started": "Le suivi a commencé le",
            "change": "Changement",
            "tracked_items_over_time": "Article suivis au cours du temps",
            "food_waste_code_vs_food_cost": "Coût des ingrédients vs coût du gaspillage",
            "enter_monthly_food_cost": "Insère ton food cost mensuel",
            "food_cost": "Coût des ingrédients",
            "food_waste_cost": "Coût du gaspillage",
            "baseline_food_cost": "Coût des ingrédients durant la période de référence",
            "baseline_food_waste_cost": "Coût du gaspillage durant la période de référence",
            "monthly_food_cost": "Coût mensuel des ingrédients",
            "enter_your_total_food_cost": "Indiquez le montant total de vos dépenses alimentaires au cours des derniers mois",
            "monthly_savings": "Épargnes mensuelles",
            "average_monthly_savings": "Épargne mensuelle moyenne",
            "average_reduction": "Réduction moyenne",
            "expected_annual_savings": "Épargnes annuelles estimées (sur la base de la moyenne)",
            "expected_savings_for": "épargne attendue pour 1 an",
            "coming_soon": "Ta page d'objectifs sera visible une fois que tes objectifs de réduction des déchets auront été défini et après les 60 premiers jours de mesure",
            "monthly_savings_tooltip_header": "Objectif mensuel",
            "monthly_savings_tooltip_paragraph_1": "Pour obtenir des résultats, il est important de fixer des objectifs et de mettre en œuvre un plan d'action. Nous recommandons de commencer avec un objectif de réduction de 20 %.",
            "monthly_savings_tooltip_paragraph_2": "Pour mesurer vos progrès, nous calculons la différence entre la quantité mensuelle (kg) des déchets alimentaires à la quantité de référence que vous avez fixée. Si les barres bleue et verte sont au même niveau, vous avez atteint votre objectif. C'est donc le moment de vous en fixer un nouveau.",
            "baseline_results_are": "Les résultats de la période de référence sont",
            "and": "et",
            "total_savings": "Epargne totale",
            "wpg": "PPC",
            "meals": "repas",
            "calculation_multipliers": "Multiplicateurs de calcul",
            "calculation_multipliers_text": "Ces multiplicateurs sont utilisés pour déterminer une moyenne de repas économisés et de CO2 produit.",
            "meals_saved": "Repas épargnés",
            "set_multipliers": "Multiplicateur actuellement défini",
            "per_guest": "par couvert",
            "avg_set": "Moyenne définie",
            "per_kg": "par kg",
            "per_meal": "par repas"
        },
        "month": {
            "january": "Janvier",
            "february": "Février",
            "march": "Mars",
            "april": "Avril",
            "may": "Mai",
            "june": "Juin",
            "july": "Juillet",
            "august": "Août",
            "september": "Septembre",
            "october": "Octobre",
            "november": "Novembre",
            "december": "Décembre"
        },
        "notifications": {
            "new": "Nouveau",
            "earlier": "Avant",
            "notifications": "Notifications",
            "no_notifications": "Pas des notifications",
            "load_more": "Charger plus",
            "end_of_feed": "Fin de liste"
        },
        "relative_times": {
            "seconds": "sec.",
            "minutes": "min.",
            "hours": "hr.",
            "days": "j.",
            "months": "m.",
            "years": "ans"
        }
    }
}